import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW0301Component } from './kymw0301.component';

import { AppCommonsModule } from '../../../commons/app-commons.module';

import { GetCandidateGoodsListService } from './api-services/get-candidate-goods-list.service';
import { MakeCandidateGoodsFileService } from './api-services/make-candidate-goods-file.service';


/**
 * 候補リスト画面 モジュール設定クラス
 *
 * @export KYMW0301Module
 * @class KYMW0301Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
  ],
  declarations: [
    KYMW0301Component,
  ],
  providers: [
    GetCandidateGoodsListService,
    MakeCandidateGoodsFileService,
  ]
})
export class KYMW0301Module {
}
